import React, { ReactNode, ComponentType } from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';

import { hasPermission } from '~src/store/session/session.reducer';
import { StoreI } from '~src/rootReducer';
import { UserPermissions } from '~src/interfaces/session.types';
import { routes } from '~src/routingConfig';

interface StateProps {
  isAuthorized: boolean;
}

interface OwnProps {
  isAuthenticated: boolean;
  path: string;
  component?: ComponentType<any>;
  requiredPermissions?: UserPermissions[];
  exact?: boolean;
  render?(props: RouteComponentProps<any>): JSX.Element;
}

type Props = OwnProps & StateProps;

interface State {
  redirectPath: string;
}

class Authenticated extends React.Component<Props, State> {
  static defaultProps = {
    isAuthenticated: false,
    isAuthorized: false,
    requiredPermissions: [],
  };

  redirectPath: string = routes.login;

  updateRedirect() {
    const uri = document.location.pathname + document.location.search;
    if (uri !== routes.logout) {
      this.redirectPath = `${routes.login}?location=${uri}`;
    } else {
      this.redirectPath = routes.login;
    }
  }

  renderRoute = (props: RouteComponentProps<any>): ReactNode => {
    const { isAuthenticated, component, isAuthorized, render } = this.props;
    this.updateRedirect();

    if (isAuthenticated && isAuthorized) {
      return component
        ? React.createElement(component, {
            ...props,
            isAuthenticated,
          })
        : render && render(props);
    } else {
      return <Redirect to={this.redirectPath} />;
    }
  };

  render() {
    const { isAuthenticated, component, render, ...rest } = this.props;

    return <Route {...rest} render={this.renderRoute} />;
  }
}

const mapState2Props = (state: StoreI, ownProps: OwnProps): StateProps => ({
  isAuthorized: hasPermission(state, ownProps.requiredPermissions || []),
});

const AuthenticatedC = connect(mapState2Props)(Authenticated);

export default AuthenticatedC;
